import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

@Injectable({providedIn: 'root'})
export class CoachProfileService {

  private apiPrefix = '/coach/profile';

  constructor(
    private api: ApiService,
  ) {
  }

  getProfile(): Observable<any> {
    return this.api.get(`${this.apiPrefix}`);
  }

  updateProfile(data: object): Observable<any> {
    return this.api.patch(`${this.apiPrefix}`, data);
  }
}
